import { useMutation } from "@apollo/client/react";
import { yupResolver } from "@hookform/resolvers/yup";
import FormInputText from "@repo/components/src/forms/text";
import LoadingButton from "@repo/components/src/shared/loadingButton";
import { BasicModal } from "@repo/components/src/shared/modal";
import { WooCommerceStartInstallDocument } from "@repo/graphql/documents/ecommerce/mutation.generated";
import { ExternalPathString, router } from "expo-router";
import React, { useCallback } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  connectWooCommerceSchema,
  ConnectWooCommerceSchemaType,
} from "./schema";

type Props = {
  brandId: string;
};

const ConnectWooCommerce = (props: Props) => {
  const { brandId } = props;
  const formProps = useForm<ConnectWooCommerceSchemaType>({
    resolver: yupResolver(connectWooCommerceSchema),
    defaultValues: {
      host: "",
    },
    mode: "onChange",
  });
  const [startInstall, { loading }] = useMutation(
    WooCommerceStartInstallDocument,
    {
      onCompleted: (data) => {
        if (data?.ecommerce?.woocommerceInstallRequest?.url) {
          router.replace(
            data.ecommerce.woocommerceInstallRequest.url as ExternalPathString,
          );
        }
      },
    },
  );
  const onSubmit: SubmitHandler<ConnectWooCommerceSchemaType> = useCallback(
    (data) => {
      startInstall({
        variables: {
          startInstallInput: {
            brandId,
            host: data.host,
          },
        },
      });
    },
    [brandId, startInstall],
  );
  return (
    <BasicModal
      title="Conectar tienda de WooCommerce"
      cancelButton={{
        text: "Cancelar",
        props: { size: "sm", rounded: "lg", action: "brand" },
      }}
      footer={
        <LoadingButton
          action="brand"
          variant="solid"
          size="sm"
          rounded="lg"
          loading={loading}
          onPress={() => formProps.handleSubmit(onSubmit)()}
        >
          Conectar
        </LoadingButton>
      }
    >
      <FormInputText
        control={formProps.control}
        name={"host"}
        placeholder={"Ej: https://tutienda.cl"}
        label={"URL de la tienda"}
        required={true}
        disabled={false}
        className={""}
        size={"sm"}
        keyboardType={"url"}
        textContentType={"URL"}
        autoCapitalize={"none"}
        labelSize={"sm"}
      />
    </BasicModal>
  );
};

export default React.memo(ConnectWooCommerce);
